import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import Logo from "./Logo";

const NAV = [
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Bölgeler", href: "#bolgeler" },
  { label: "Neden Biz", href: "#neden-biz" },
  { label: "Yorumlar", href: "#yorumlar" },
  { label: "SSS", href: "#sss" },
];

export default function Header() {
  return (
    <motion.header
      data-testid="main-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-40"
    >
      <div className="hazard-stripes h-1 w-full" aria-hidden="true" />
      <div className="bg-night-900/85 backdrop-blur-md border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
          <Logo compact />
          <nav className="hidden md:flex items-center gap-7" aria-label="Ana menü">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-link-${item.href.slice(1)}`}
                className="text-sm uppercase tracking-widest text-slate-300 hover:text-brand transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <span className="hidden lg:flex items-center gap-2 text-xs uppercase tracking-widest text-slate-400">
              <span className="w-2 h-2 rounded-full bg-wa animate-blink" aria-hidden="true" />
              7/24 Nöbetçi
            </span>
            <a
              href="tel:+905392196017"
              data-testid="header-call-button"
              className="flex items-center gap-2 bg-brand hover:bg-brand-light text-night-900 font-bold rounded-full pl-4 pr-5 py-2.5 transition-all duration-200 hover:shadow-[0_0_24px_rgba(255,107,0,0.45)] active:scale-95"
            >
              <Phone className="w-4 h-4" strokeWidth={2.5} />
              <span className="hidden sm:inline font-display text-lg tracking-wide">0539 219 60 17</span>
              <span className="sm:hidden font-display text-lg tracking-wide">Ara</span>
            </a>
          </div>
        </div>
      </div>
    </motion.header>
  );
}
